import { ReduxAction } from "../types";
// Define a type for the slice state
export interface AccountState {
	id                    	: number,
	mobile				  	: string,
	mail                  	: string,
	nickname              	: string,
	token                 	: string,
	cnName				  	: string,
	idno                  	: string,
	headimg                 : string,
}
const initialState:AccountState =
{
	id                    	: -1,
	mobile				  	: "",
	mail                  	: "",
	nickname              	: "",
	token                 	: "",
	cnName				  	: "",
	idno                  	: "",
	headimg                 : "",
};
/**
 * 账户相关的配置
 * @param state 
 * @param action 
 * @returns 
 */
const account = (state = initialState, action:ReduxAction):AccountState =>
{
	switch (action.type)
	{
		case 'SET_LOGIN_USER':
		{
			return {
				...state,
				...action.payload,
			};
		}
		case 'SET_JWT':
		{
			const {token} = action.payload; 
			return {
				...state,
				token,
			};
		}
		case 'LOGOUT':
		{
			return {
				...initialState
			};
		}
		default:
			return state;
	}
};

export default account;
